import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AtendenteService } from '../../../services/atendente.service';
import { Atendente } from '../../../models/atendente.model';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-transferir-conversa-modal',
  templateUrl: './transferir-conversa-modal.component.html',
  styleUrls: ['./transferir-conversa-modal.component.scss']
})
export class TransferirConversaModalComponent implements OnInit, OnDestroy {
  @Input() conversaId!: string;
  @Input() nomeContato?: string;

  transferirForm!: FormGroup;
  submitted = false;
  isLoading = false;
  isLoadingAtendentes = false;
  atendentes: Atendente[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private atendenteService: AtendenteService,
    public activeModal: NgbActiveModal,
    private toastService: ToastService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.carregarAtendentes();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initForm(): void {
    this.transferirForm = this.fb.group({
      atendenteId: ['', [Validators.required]],
      motivo: ['']
    });
  }

  carregarAtendentes(): void {
    this.isLoadingAtendentes = true;
    this.atendenteService.listarAtendentes('online')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          // Filtrar apenas atendentes online e ausentes (não offline)
          this.atendentes = (response.atendentes || []).filter(
            a => a.status === 'online' || a.status === 'ausente'
          );
          this.isLoadingAtendentes = false;
        },
        error: (error) => {
          console.error('Erro ao carregar atendentes:', error);
          this.toastService.show('Erro ao carregar lista de atendentes', {
            classname: 'bg-danger text-light',
          });
          this.isLoadingAtendentes = false;
        }
      });
  }

  get f() {
    return this.transferirForm.controls;
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.transferirForm.invalid) {
      Object.keys(this.transferirForm.controls).forEach(key => {
        this.transferirForm.get(key)?.markAsTouched();
      });
      return;
    }

    this.isLoading = true;

    const formValue = this.transferirForm.value;
    const motivo = formValue.motivo?.trim() || undefined;

    // Retornar os dados para o componente pai processar a transferência
    // O valor é o atendenteId do atendente selecionado
    this.activeModal.close({
      atendenteId: formValue.atendenteId,
      motivo: motivo
    });
  }

  fechar(): void {
    this.activeModal.dismiss();
  }
}
